import './style.less';

export default function($log, $scope, $stateParams, $location) {
  'ngInject';

  const vm = this;

  vm.stateParams = $stateParams;

  switch ($stateParams.tab) {
    case 'all':
      vm.activeTab = 1;
      break;
    default:
      vm.activeTab = 0;
  }

  vm.changeTab = tab => $location.search('tab', tab);

  $log.debug('Users Learning Courses Activated');
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/learning/courses/index.js